export const iconCss = {
  root: { "--icon-stroke-width": "3px" },
};
